import { useMemo } from "react";
import { Alert } from "react-bootstrap";
import "./ExportColumnSelector.scss";
import FieldAvailableItem from "./FieldAvailableItem";
import { FieldAvailable, getFieldsAvailable } from "./get-fields-available";

interface ExportColumnSelectorProps {
  columnOrder: string[];
  onFieldsUpdated: (fields: FieldAvailable[]) => void;
}

const ExportColumnSelector: React.FC<ExportColumnSelectorProps> = ({
  columnOrder: externalColumnOrder,
  onFieldsUpdated,
}) => {
  const fieldsAvailable = getFieldsAvailable();

  const fieldsSelected = useMemo(() => {
    return fieldsAvailable.filter((field) =>
      externalColumnOrder.includes(field.key),
    );
  }, [fieldsAvailable, externalColumnOrder]);

  const unselectedFields = useMemo(() => {
    return fieldsAvailable.filter((field) => !fieldsSelected.includes(field));
  }, [fieldsAvailable, fieldsSelected]);

  return (
    <div className="export-column-selector">
      <div className="export-builder-header">Export Builder</div>
      <div className="two-column-layout">
        <div className="left-column">
          <div className="column-header">Fields Available</div>
          <div className="fields-available">
            {unselectedFields.length === 0 && (
              <Alert variant="info">
                You've selected all available fields.
              </Alert>
            )}
            {unselectedFields.map((field) => (
              <FieldAvailableItem
                key={field.name}
                field={field}
                type="available"
                onClick={(field) => onFieldsUpdated([...fieldsSelected, field])}
              />
            ))}
          </div>
        </div>
        <div className="right-column">
          <div className="column-header">Fields Selected</div>
          <div className="fields-selected">
            {fieldsSelected.length === 0 && (
              <Alert variant="info">No fields selected.</Alert>
            )}
            {fieldsSelected.map((field) => (
              <FieldAvailableItem
                key={field.name}
                field={field}
                type="selected"
                onClick={(field) =>
                  onFieldsUpdated(
                    fieldsSelected.filter((f) => f.name !== field.name),
                  )
                }
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportColumnSelector;
